import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m11__message c-form-inner--wide" }
const _hoisted_2 = { class: "p-form-button-group" }
const _hoisted_3 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, {
    class: "p-the-page-m11",
    "is-simple-header": true,
    step: _ctx.step,
    "step-options": _ctx.stepOptions
  }, {
    heading: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("メールアドレス変更", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "p-the-page-m11__message__text" }, " メールアドレスの変更が完了しました。 ", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ButtonMain, {
              tag: 'a',
              href: "/"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("ログインする", -1)
              ])),
              _: 1,
              __: [1]
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["step", "step-options"]))
}